import React from 'react';
import { AtSignIcon, MailIcon } from 'lucide-react';
import { agent } from '../../data/content';
export function SiteFooter() {
  return <footer className="w-full border-t border-ink-border/60 bg-pitch" data-id="element-162" data-mp="1bdisabxs0cw1">
      <div className="mx-auto max-w-4xl px-5 pb-28 pt-14 text-center md:pb-14" data-id="element-163" data-mp="1fhqh0948hsu9">
        <p className="text-lg font-extrabold text-white" data-id="element-164" data-mp="1kga4idyh7coq">{agent.name}</p>
        <p className="mt-1 text-sm text-body" data-id="element-165" data-mp="1kde5emaw6hyp">{agent.credential}</p>
        <p className="mt-1 text-sm text-subtle" data-id="element-166" data-mp="nr2ht2m4exj8">Asesoramiento para padres de futbolistas</p>
        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-body" data-id="element-167" data-mp="rrw27m0ctu7d">
          <li data-id="element-168" data-mp="womgq4wighqo">
            <a href="mailto:solucionesoinformacion@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-169" data-mp="wo32oz9zedhx">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-170" data-mp="3znxf4gnj9js" />
              solucionesoinformacion@gmail.com
            </a>
          </li>
          <li data-id="element-171" data-mp="ande25we5goh">
            <a href="https://instagram.com/metodofutboldigital" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-172" data-mp="altvu9r6cvk2">
              <AtSignIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="1syxm004k03s" />
              metodofutboldigital
            </a>
          </li>
        </ul>
        <p className="mt-8 text-xs text-subtle" data-id="element-174" data-mp="3o1ru0hy5h7sx">
          © 2026 {agent.name} — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}